var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do Termo",
      "outlined": "",
      "maxlength": "40",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.termo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "termo", $$v);
      },
      expression: "form.filters.termo"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarTermos();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterTermo();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listTermos,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: `item.tipo`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.tipo.descricao) + " ")];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.situacao
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarTermo(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true,
            "disabled": !item.situacao
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterTermo(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.situacao ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.situacao ? 'var(--primary-button-color)' : 'silver'}`,
            "small": true,
            "disabled": !item.situacao
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarTermo(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarTermoDialog', {
    attrs: {
      "visible": _vm.dialogManterTermo.visible,
      "content": _vm.dialogManterTermo.content,
      "edit": _vm.dialogManterTermo.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterTermo.close();
      },
      "onSave": function ($event) {
        return _vm.buscarTermos();
      }
    }
  }), _c('VisualizarTermoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarTermo.visible,
      "content": _vm.dialogVisualizarTermo.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarTermo.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }